import React from 'react'

interface TextAreaProps {
  rows?: number
  placeholder?: string
  label?: string
  required?: boolean
  className?: string
  name?: string
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  error?: string
}

const TextArea: React.FC<TextAreaProps> = ({
  rows = 8,
  placeholder = 'Enter text here...',
  label,
  required = false,
  className = '',
  name = '',
  value = '',
  onChange = () => {
    ''
  },
  error,
  ...props
}) => {
  return (
    <div className="relative mb-5">
      {label && (
        <label className="mb-1 flex text-sm leading-none font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <textarea
        {...props}
        rows={rows}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full rounded-md border px-4 py-3 text-black placeholder-gray-500 focus:border-gray-400 focus:outline-none ${className} ${error ? 'border-red-500' : ''}`}
      ></textarea>

      {error && <p className="absolute text-xs leading-none text-red-500">{error}</p>}
    </div>
  )
}

export default TextArea
